<template>
  <div class="container">
    <div class="row imprint">
      <div class="col-12">
        <h3>{{$t('title')}}</h3>

        <h4>{{$t('tmg.title')}}</h4>
        <address>
          <span class="name">Alexej Gornizki</span><br>
          <span class="street">Herderstr. 7</span><br>
          <span class="zip">10625</span> <span class="city">Berlin</span><br>
          <span class="country">{{$t('tmg.germany')}}</span><br>
          {{$t('tmg.phone')}}: <span class="phone">+49 176 476 42003</span><br>
          {{$t('tmg.email')}}: <span class="email">
            <a href="mailto:alex@fontanelabs.de">alex@fontanelabs.de</a>
          </span><br>
          {{$t('tmg.website')}}: <span class="website">
            <a href="https://fontanelabs.de">fontanelabs.de</a>
          </span>
        </address>

        <h4>{{$t('content.title')}}</h4>
        <p>{{$t('content.content')}}</p>

        <h4>{{$t('links.title')}}</h4>
        <p>{{$t('links.content')}}</p>

        <h4>{{$t('copyright.title')}}</h4>
        <p>{{$t('copyright.content')}}</p>

        <div id="source">
          <i>{{$t('source.title')}}:</i>
          <a :href="$t('source.url')" target="_blank">
            {{$t('source.label')}}
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<i18n>
en:
  title: Legal Disclosure
  tmg:
    title: Information in accordance with Section 5 TMG
    germany: Germany
    phone: Phone
    email: E-Mail
    website: Website
  content:
    title: Accountability for content
    content: |
      The contents of our pages have been created with the utmost care.
      However, we cannot guarantee the contents' accuracy, completeness or
      topicality. According to statutory provisions, we are furthermore
      responsible for our own content on these web pages. In this matter,
      please note that we are not obliged to monitor the transmitted or saved
      information of third parties, or investigate circumstances pointing to
      illegal activity. Our obligations to remove or block the use of
      information under generally applicable laws remain unaffected by this as
      per §§ 8 to 10 of the Telemedia Act (TMG).
  links:
    title: Accountability for links
    content: |
      Responsibility for the content of external links (to web pages of third
      parties) lies solely with the operators of the linked pages. No
      violations were evident to us at the time of linking. Should any legal
      infringement become known to us, we will remove the respective link
      immediately.
  copyright:
    title: Copyright
    content: |
      Our web pages and their contents are subject to
      German copyright law. Unless expressly permitted by law, every form of
      utilizing, reproducing or processing works subject to copyright
      protection on our web pages requires the prior consent of the respective
      owner of the rights. Individual reproductions of a work are only allowed
      private use. The materials from these pages are copyrighted and any
      unauthorized use may violate copyright laws.
  source:
    title: Source
    url: http://www.translate-24h.de
    label: impressum generator at translate-24h.de
de:
  title: Impressum
  tmg:
    title: Angaben gemäß § 5 TMG
    germany: Deutschland
    phone: Telefon
    email: E-Mail
    website: Webseite
  content:
    title: Haftung für Inhalte
    content: |
      Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den
      allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch
      nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder
      nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.
      Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den
      allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst
      ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von
      entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.
  links:
    title: Haftung für Links
    content: |
      Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen
      Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen.
      Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der
      Seiten verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche
      Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht
      erkennbar. Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne
      konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von
      Rechtsverletzungen werden wir derartige Links umgehend entfernen.
  copyright:
    title: Urheberrecht
    content: |
      Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem
      deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der
      Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des
      jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite sind nur für den
      privaten, nicht kommerziellen Gebrauch gestattet. Soweit die Inhalte auf dieser Seite nicht
      vom Betreiber erstellt wurden, werden die Urheberrechte Dritter beachtet. Insbesondere werden
      Inhalte Dritter als solche gekennzeichnet. Sollten Sie trotzdem auf eine
      Urheberrechtsverletzung aufmerksam werden, bitten wir um einen entsprechenden Hinweis. Bei
      Bekanntwerden von Rechtsverletzungen werden wir derartige Inhalte umgehend entfernen.
  source:
    title: Quelle
    url: https://www.e-recht24.de/impressum-generator.html
    label: https://www.e-recht24.de/impressum-generator.html
</i18n>

<script>
export default {
  name: 'Imprint',
  data() {
    return {

    };
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .imprint {
    margin-top: 20px;
    margin-bottom: 50px;
  }

  address {
    line-height: 1.2em;
  }

  address > .name {
    font-weight: bold;
  }
</style>



// WEBPACK FOOTER //
// src/components/Imprint.vue